import { EpisodeProgress, episodeProgressKey, getResumePosition } from './slice';
import { RootState } from '../../../app/reducer';
import { PodcastEpisodeModel } from '../../../models/Podcast.model';

/** Most recently interrupted episode that can be resumed (APPS-2160). */
export type ResumeEpisode = {
  episode: PodcastEpisodeModel;
  position: number;
  duration: number;
};

export const selectPodcastReadList = ({ podcastListReducer }: RootState): string[][] =>
  podcastListReducer.readList;

export const selectPodcastProgressByEpisode = ({
  podcastListReducer,
}: RootState): Record<string, EpisodeProgress> => podcastListReducer.progressByEpisode;

export const selectEpisodeProgress =
  (podcastId: string, episodeId: string) =>
  (state: RootState): EpisodeProgress | undefined =>
    state.podcastListReducer.progressByEpisode[episodeProgressKey(podcastId, episodeId)];

export const selectResumeEpisode = (state: RootState): ResumeEpisode | undefined => {
  const { progressByEpisode, readList } = state.podcastListReducer;
  let latest: EpisodeProgress | undefined;
  for (const progress of Object.values(progressByEpisode)) {
    if (!progress.episode) {
      continue;
    }
    const isRead = readList.some(
      ([pId, eId]) => pId === progress.podcastId && eId === progress.episodeId,
    );
    if (getResumePosition(progress, isRead) <= 0) {
      continue;
    }
    if (!latest || progress.updatedAt > latest.updatedAt) {
      latest = progress;
    }
  }
  if (!latest?.episode) {
    return undefined;
  }
  return {
    episode: latest.episode,
    position: latest.position,
    duration: latest.duration,
  };
};
